import { createTheme, Theme } from "@mui/material/styles";
import globalColors from "./globalColors";
declare module "@mui/material/styles" {
  interface TypographyVariants {
    heading1: React.CSSProperties;
    Heading2: React.CSSProperties;
    Heading3: React.CSSProperties;
    subheading1: React.CSSProperties;
    subheading2: React.CSSProperties;
    buttonText1: React.CSSProperties;
    buttonText2: React.CSSProperties;
    sectionText1: React.CSSProperties;
    title1: React.CSSProperties;
    accordianHeading: React.CSSProperties;
    body1: React.CSSProperties;
    content1: React.CSSProperties;
    content2: React.CSSProperties;
    centreHeading1: React.CSSProperties;
    centreHeading2: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    heading1?: React.CSSProperties;
    Heading2?: React.CSSProperties;
    Heading3?: React.CSSProperties;
    subheading1?: React.CSSProperties;
    subheading2?: React.CSSProperties;
    buttonText1?: React.CSSProperties;
    buttonText2?: React.CSSProperties;
    sectionText1?: React.CSSProperties;
    title1?: React.CSSProperties;
    accordianHeading?: React.CSSProperties;
    body1?: React.CSSProperties;
    content1?: React.CSSProperties;
    content2?: React.CSSProperties;
    centreHeading1?: React.CSSProperties;
    centreHeading2?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    heading1: true;
    Heading2: true;
    Heading3: true;
    subheading1: true;
    subheading2: true;
    sectionText1: true;
    buttonText1: true;
    buttonText2: true;
    title1: true;
    accordianHeading: true;
    body1: true;
    content1: true;
    content2: true;
    centreHeading1: true;
    centreHeading2: true;
  }
}

const theme: Theme = createTheme({
  palette: {
    primary: {
      main: globalColors.primary.black, // Replace with your desired primary color
    },  
    secondary: {
      main: globalColors.primary.white, // Replace with your desired secondary color
    },
  },
  typography: {
    fontFamily:"Inter",
    heading1: {
      fontWeight: 600,
      fontSize: "24px",
      lineHeight: "36px",
      fontFamily: "Inter",
    },
    Heading2: {
      fontWeight: 600,
      fontSize: "20px",
      lineHeight: "30px",
      fontFamily: "Inter",
    },
    Heading3: {
      fontWeight: 600,
      fontSize: "18px",
      lineHeight: "27px",
      fontFamily: "Inter",
    },
    subheading1: {
      fontWeight: 600,
      fontSize: "0.9rem",
      lineHeight: "24px",
      fontFamily: "Inter",
    },
    subheading2: {
      fontWeight: 600,
      fontSize: "0.8rem",
      lineHeight: "21px",
      fontFamily: "Inter",
    },
    buttonText2: {
      fontWeight: 600,
      fontStyle: "italic",
      fontSize: "0.8rem",
      lineHeight: "21px",
      fontFamily: "Inter",
    },
    buttonText1: {
      fontWeight: 500,
      fontSize: "0.9rem",
      lineHeight: "24px",
      fontFamily: "Inter",
    },
    sectionText1: {
      fontWeight: 500,
      fontSize: "0.9rem",
      lineHeight: "24px",
      fontFamily: "Inter",
    },
    title1: {
      fontWeight: 500,
      fontStyle: "italic",
      fontSize: "0.8rem",
      lineHeight: "21px",
      fontFamily: "Inter",
    },
    content2: {
      fontWeight: 500,
      fontStyle: "italic",
      fontSize: "12px",
      lineHeight: "18px",
      fontFamily: "Inter",
    },
    centreHeading1: {
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "18px",
      letterSpacing: "1.8px",
      fontFamily: "Inter",
      textTransform: "uppercase",
      textAlign: "center",
    },
    centreHeading2: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "18px",
      letterSpacing: "1.8px",
      fontFamily: "Inter",
      textTransform: "uppercase",
      textAlign: "center",
    },
    accordianHeading: {
      fontWeight: 400,
      fontSize: "0.8rem",
      lineHeight: "21px",
      letterSpacing: "5%",
      fontFamily: "Inter",
    },
    body1: {
      fontWeight: 400,
      fontSize: "0.8rem",
      lineHeight: "21px",
      fontFamily: "Inter",
    },
    content1: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "18px",
      fontFamily: "Inter",
    },

    // Add more typography customizations as needed
  },
  components: {MuiStepIcon: {
  styleOverrides: {
    root: {
      // color: "#ccc",
    
      "&.Mui-completed": {
        color: "#519C66",
      },
    },
  },
},
    MuiButton: {
      styleOverrides: {
        // {
        //   "root": {
        //     "&.Mui-disabled": {
        //       "backgroundColor": "rgba(200, 200, 200, 1)",
        //       "color": "rgba(131, 131, 131, 1)"
        //     }
        //   }
        // }
        
        root: {
          // color: (theme) => (theme.palette.primary.main === globalColors.primary.black ? theme.palette.common.white : 'inherit'),
        },
        outlined:{border:`1px solid ${globalColors.primary.black}`},
        contained: {
          backgroundColor: globalColors.primary.black, // Customize the background color for contained buttons
          color: globalColors.primary.white, // Customize the text color for contained buttons
          '&:hover': {
            // backgroundColor: globalColors.primary.darkBlack, // Customize the background color on hover for contained buttons
          },
        },
        // disabled: {
        //   // Styles for the disabled state
        //   backgroundColor: globalColors.primary.disableBg, // Customize the background color for disabled buttons
        //   color: globalColors.primary.disableText, // Customize the text color for disabled buttons
        // },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          heading1: "p",
          Heading2: "p",
          Heading3: "p",
          subheading1: "p",
          subheading2: "p",
          buttonText1: "p",
          buttonText2: "p",
          sectionText1: "p",
          title1: "p",
          accordianHeading: "p",
          body1: "p",
          content1: "p",
          content2: "p",
          centreHeading1: "p",
          centreHeading2: "p",
        },
      },
    },
  
  },
});

export default theme;
